// ─────────────────────────────────────────────────────────────
// FUTURES INSTRUMENTS — symbols, tick sizes, tick values
// ─────────────────────────────────────────────────────────────

export const DEFAULT_INSTRUMENTS = [
  { symbol: "NQ",   description: "E-mini NASDAQ-100",          tickSize: 0.25,     tickValue: 5.00    },
  { symbol: "MNQ",  description: "Micro NASDAQ-100",           tickSize: 0.25,     tickValue: 0.50    },
  { symbol: "ES",   description: "E-mini S&P 500",             tickSize: 0.25,     tickValue: 12.50   },
  { symbol: "MES",  description: "Micro S&P 500",              tickSize: 0.25,     tickValue: 1.25    },
  { symbol: "YM",   description: "E-mini Dow Jones",           tickSize: 1.00,     tickValue: 5.00    },
  { symbol: "MYM",  description: "Micro Dow Jones",            tickSize: 1.00,     tickValue: 0.50    },
  { symbol: "RTY",  description: "E-mini Russell 2000",        tickSize: 0.10,     tickValue: 5.00    },
  { symbol: "M2K",  description: "Micro Russell 2000",         tickSize: 0.10,     tickValue: 0.50    },
  { symbol: "CL",   description: "Crude Oil",                  tickSize: 0.01,     tickValue: 10.00   },
  { symbol: "MCL",  description: "Micro Crude Oil",            tickSize: 0.01,     tickValue: 1.00    },
  { symbol: "NG",   description: "Natural Gas",                tickSize: 0.001,    tickValue: 10.00   },
  { symbol: "GC",   description: "Gold",                       tickSize: 0.10,     tickValue: 10.00   },
  { symbol: "MGC",  description: "Micro Gold",                 tickSize: 0.10,     tickValue: 1.00    },
  { symbol: "SI",   description: "Silver",                     tickSize: 0.005,    tickValue: 25.00   },
  { symbol: "ZN",   description: "10-Year T-Note",             tickSize: 0.015625, tickValue: 15.625  },
  { symbol: "ZB",   description: "30-Year T-Bond",             tickSize: 0.03125,  tickValue: 31.25   },
  { symbol: "6E",   description: "Euro FX",                    tickSize: 0.00005,  tickValue: 6.25    },
  { symbol: "6B",   description: "British Pound",              tickSize: 0.0001,   tickValue: 6.25    },
  { symbol: "ZC",   description: "Corn",                       tickSize: 0.25,     tickValue: 12.50   },
  { symbol: "ZS",   description: "Soybeans",                   tickSize: 0.25,     tickValue: 12.50   },
  { symbol: "ZW",   description: "Wheat",                      tickSize: 0.25,     tickValue: 12.50   },
  { symbol: "BTC",  description: "Bitcoin Futures (CME)",      tickSize: 5.00,     tickValue: 25.00   },
  { symbol: "MBT",  description: "Micro Bitcoin Futures",      tickSize: 5.00,     tickValue: 2.50    },
  { symbol: "ETH",  description: "Ether Futures (CME)",        tickSize: 0.25,     tickValue: 12.50   },
  { symbol: "MET",  description: "Micro Ether Futures",        tickSize: 0.25,     tickValue: 1.25    },
];

export function getTickInfo(symbol = "", userSettings = []) {
  const s = symbol.toUpperCase().trim();
  const custom = userSettings.find(u => u.symbol.toUpperCase() === s);
  if (custom) return { tickSize: Number(custom.tick_size), tickValue: Number(custom.tick_value) };
  const builtin = DEFAULT_INSTRUMENTS.find(d => d.symbol === s);
  if (builtin) return { tickSize: builtin.tickSize, tickValue: builtin.tickValue };
  const partial = DEFAULT_INSTRUMENTS.find(d => s.startsWith(d.symbol));
  if (partial) return { tickSize: partial.tickSize, tickValue: partial.tickValue };
  return { tickSize: 0.01, tickValue: 1.00 };
}
